export class UniBrandCalculationModel {
    ProductionReportCalculationID: number;
    ProductionReportTypeID: number;
    LongName: string;
    ShortName: string;
    ProductionListID: number;
    CalculationTC: string;
    VatInclExclNvtTC: string;
    VatTC?: any;
    CreatedDate: Date;
    CreatedByUserId: number;
    CalcTag: string;
    FaseOutTC: string;
    VersionNumber: number;

    public constructor(init?: Partial<UniBrandCalculationModel>) {
        Object.assign(this, init);
    }
}

